import { FormControlLabel, Switch, SwitchProps } from '@mui/material';
import { Controller, FieldValues, UseControllerProps } from 'react-hook-form';

type ConnectedSwitchProps<TFieldValues extends FieldValues> = 
    SwitchProps &
    UseControllerProps<TFieldValues> & {
        label?: string;
    }

function ConnectedSwitch<TFieldValues extends FieldValues>({ 
    control, 
    name, 
    rules,
    label,
    disabled,
    ...rest 
}: ConnectedSwitchProps<TFieldValues>) {
    return (
        <Controller 
            name={ name }
            control={ control }
            rules={ rules }
            render={ ({ field: { value, onChange, ref } }) => (
                <FormControlLabel
                    control={
                        <Switch
                            checked={ !!value }
                            onChange={ (e) => onChange(e.target.checked) }
                            inputRef={ ref }
                            disabled={ disabled }
                            { ...rest }
                        />
                    }
                    label={ label }
                />
            ) }
        />
    );
}

export default ConnectedSwitch;
